export default "__VITE_ASSET__BB73IVSQ__"